import { render, staticRenderFns } from "./CandidatePublicCouncil.vue?vue&type=template&id=b143644c&scoped=true&"
import script from "./CandidatePublicCouncil.vue?vue&type=script&lang=js&"
export * from "./CandidatePublicCouncil.vue?vue&type=script&lang=js&"
import style0 from "./CandidatePublicCouncil.vue?vue&type=style&index=0&id=b143644c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b143644c",
  null
  
)

export default component.exports